import useAxiosInstance from "../lib/useAxiosInstance";

export const useStartOrOpenChat = () => {
  const axiosInstance = useAxiosInstance();

  const startOrOpenChat = async (contactId, openChatCallback) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));

      // 1️⃣ Check if a conversation already exists
      const res = await axiosInstance.get("/api/chat/conversations");
      const existing = res?.data?.data?.find((c) =>
        c.participants.some((p) => p.user?._id === contactId)
      );

      // 2️⃣ If it exists → open it
      if (existing) {
        if (openChatCallback) openChatCallback(existing._id);
        else if (window.openChat) window.openChat(existing._id);
        return existing;
      }

      // 3️⃣ Else → create new conversation
      const newConvo = await axiosInstance.post("/api/chat/conversations", {
        participants: [{ user: contactId, role: "member" }],
        isGroup: false,
      });

      const convo = newConvo?.data?.data;
      if (openChatCallback) openChatCallback(convo._id);
      else if (window.openChat) window.openChat(convo._id);

      return convo;
    } catch (err) {
      console.error("Error starting chat:", err);
      throw err;
    }
  };

  return { startOrOpenChat };
};
